import { NgClass, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslocoModule } from '@jsverse/transloco';

import { IconComponent } from './components/icon/icon.component';
import { SdgIconComponent } from './components/sdg-icon/sdg-icon.component';

@NgModule({
  declarations: [
    IconComponent,
    SdgIconComponent
  ],
  imports: [
    TranslocoModule,
    NgClass,
    NgIf
  ],
  exports: [
    IconComponent,
    SdgIconComponent
  ]
})
export class UiIconsModule {}
